import { Banknote, Search, type LucideIcon } from "lucide-react";

export const pricingPageIntro = {
  eyebrow: "Preços",
  title: "Sem subscrições. Sem fidelização.",
  body: "Pesquise grátis. Só paga quando quiser o relatório completo, com evidência por fonte e PDF para guardar.",
} as const;

export type PricingPlanDefinition = {
  title: string;
  price: string;
  cta: string;
  features: readonly string[];
  icon: LucideIcon;
};

export const pricingPlans: { search: PricingPlanDefinition; full: PricingPlanDefinition } = {
  search: {
    title: "Pesquisa",
    price: "Grátis",
    cta: "Pesquisar agora",
    features: [
      "Identidade da empresa (NIF e dados base)",
      "Nível de risco em intervalo",
      "4 categorias gratuitas",
      "Data da última verificação",
    ],
    icon: Search,
  },
  full: {
    title: "Relatório completo",
    price: "19,99 €",
    cta: "Desbloquear relatório",
    features: ["Score exato (0-100)", "Todas as categorias", "Evidência por fonte", "Recomendações práticas + PDF"],
    icon: Banknote,
  },
};

/** Home page pricing strip (above footer) */
export const homePricingBand = {
  eyebrow: "Relatório único",
  title: "Pesquise grátis. Pague só se precisar de detalhe.",
  body: "Quando desbloqueia, recebe score exato, categorias completas, evidência por fonte e PDF pronto a partilhar.",
  badge: "Lançamento",
  price: "19,99 €",
  subline: "Pagamento único · acesso permanente · PDF incluído",
  cta: "Comparar planos",
} as const;

export const pricingProofItems = [
  {
    value: "1 200+",
    label: "stands já verificados",
  },
  {
    value: "9",
    label: "categorias de risco",
  },
  {
    value: "PDF",
    label: "incluído no relatório completo",
  },
] as const;

export const billingFaqEntries: ReadonlyArray<[question: string, answer: string]> = [
  [
    "O pagamento é uma subscrição?",
    "Não. O relatório completo é um pagamento único. Não há renovação automática nem fidelização.",
  ],
  [
    "Como recupero um relatório comprado?",
    "Use o email do pagamento na área de recuperação. Enviamos novamente os links associados a esse email.",
  ],
  [
    "Posso pedir reembolso?",
    "Se o relatório não ficar disponível por falha técnica do serviço, contacte-nos com o ID do relatório para resolução ou reembolso.",
  ],
];

export const pricingGuarantee = {
  title: "Garantia de entrega",
  body:
    "Se pagar e o relatório não ficar acessível por falha técnica do StandXRAY, corrigimos o acesso ou reembolsamos o pagamento. Guarde o email e o ID do relatório.",
} as const;
